import { Component, OnInit } from '@angular/core';
import { ChartDataSets, ChartType, ChartOptions } from 'chart.js';
import { Label } from 'ng2-charts';
import { ReportService } from 'src/app/services/report.service';
import { Subscription } from 'rxjs';
import { StorageMap } from '@ngx-pwa/local-storage';

@Component({
  selector: 'app-report-survey',
  templateUrl: './report-survey.component.html',
  styleUrls: ['./report-survey.component.css']
})
export class ReportSurveyComponent implements OnInit {

  constructor(private storage: StorageMap, private reportService: ReportService) { }
  dataSubscription: Subscription;
  labels: string[];
  categoriesSum: number[];
  chartOptions: ChartOptions = {
    responsive: true,
  };
  tracks: Label[];
  chartType: ChartType = 'pie';
  chartLegend = true;
  chartPlugins = [];
  chartData: ChartDataSets[] = [];
  chartData1: ChartDataSets[] = [];
  chartData2: ChartDataSets[] = [];
  hasData = false;
  question1: string;
  question2: string;
  question3: string;

  ngOnInit(): void {
    this.dataSubscription = this.storage.watch('selectedOpenId', { type: 'string' })
      .subscribe((openId) => {
        const openIdInt = parseInt(openId, 10);
        if (!isNaN(openIdInt)){
          this.getSurvey(openIdInt);
        }
      });
  }

  getSurvey(openSpaceId) {
    this.reportService.getSurvey(openSpaceId)
      .subscribe(data => {
        if (data && data.Reports.length !== 0){
          this.tracks = data.Reports[0].labels;
          this.chartData = data.Reports[0].data;
          this.question1 = data.Reports[0].data[0].label;
          this.chartData1 = data.Reports[1].data;
          this.question2 = data.Reports[1].data[0].label;
          this.chartData2 = data.Reports[2].data;
          this.question3 = data.Reports[2].data[0].label;
          this.hasData = true;
          }
      },
      error => {
        console.error(error);
      });
  }
}
